<div *ngIf="visible" 
     class="json-popup"
     [style.transform]="animationState === 'showing' ? 'translateY(0)' : 'translateY(100%)'">
  <div class="json-popup-header">
    <h5>{{ title }}</h5>
    <div class="header-center">
      <label class="identifier-label">Device ID:</label>
      <input 
        type="text" 
        class="form-control form-control-sm identifier-input" 
        [(ngModel)]="editedIdentifier"
        placeholder="Enter device ID"
        [disabled]="!editable || !isEditing">
    </div>
    <div class="header-buttons">
      <button *ngIf="editable && !isEditing" 
              class="btn btn-sm btn-outline-primary mr-2" 
              (click)="startEditing()" 
              title="Edit">
        <i class="fa fa-edit"></i> Edit
      </button>
      <button class="btn btn-sm btn-outline-secondary" (click)="onClose()" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
  <div class="json-popup-content">
    <!-- View Mode -->
    <div *ngIf="!isEditing">
      <pre [innerHTML]="getFormattedJson()"></pre>
    </div>

    <!-- Edit Mode -->
    <div *ngIf="isEditing" class="edit-mode">
      <textarea 
        class="form-control json-editor" 
        [(ngModel)]="editedJsonString"
        rows="20"
        spellcheck="false"></textarea>
      
      <div *ngIf="jsonError" class="alert alert-danger mt-2">
        {{ jsonError }}
      </div>

      <div class="edit-buttons mt-3">
        <button class="btn btn-primary mr-2" (click)="saveChanges()">
          <i class="fa fa-save"></i> Save
        </button>
        <button class="btn btn-secondary" (click)="cancelEditing()">
          <i class="fa fa-times"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</div>
